<template>
    <div>
        <div class="flex flex-col lg:flex-row">
            <div class="bg-white w-full lg:w-3/4 h-content flex-auto">
                <div v-for="(item, key) in videoData" :key="item.id">
                    <slot v-if="activeTabIndex === key" name="video" :key="key" :videoData="item"></slot>
                </div>
            </div>
            <div class="bg-white w-auto rounded-lg shadow-md m-2 h-auto">
                <div
                    v-for="(item, key) in videoData"
                    :key="item.id"
                    @click="[$emit('update:activeTab', item), (activeTabIndex = key)]"
                    class="p-2 m-2 rounded relative cursor-pointer hover:bg-zinc-200"
                >
                    <slot name="videoList" :videoData="item"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['videoData', 'activeTab', 'firstOnLoad', 'activeColor', 'overlay', 'align'],

    emits: ['update:activeTab'],

    data: () => ({
        activeTabIndex: null
    }),

    mounted() {
        if (this.firstOnLoad) {
            this.$emit('update:activeTab', _.first(this.videoData));
            this.activeTabIndex = 0;
        }
    },

    watch: {
        activeColor: function () {
            return this.activeColor;
        }
    }
};
</script>

<style scoped>
.tab-indicator {
    background-color: v-bind(activeColor);
}
</style>
